'use client';

import { useState } from 'react';

interface Props {
  phone: string;
  verified: boolean;
  onVerified: (phone: string) => void;
}

export default function PhoneVerify({ phone, verified, onVerified }: Props) {
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState('');
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [msg, setMsg] = useState('');

  const send = async () => {
    if (!/^010\d{7,8}$/.test(phone)) { setMsg('휴대폰번호를 먼저 정확히 입력해 주세요.'); return; }
    setSending(true); setMsg('');
    const res = await fetch('/api/otp/send', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone }),
    });
    const data = await res.json();
    setSending(false);
    if (res.ok) { setSent(true); setMsg('인증번호를 발송했습니다.'); }
    else setMsg(data.error ?? '발송 실패');
  };

  const verify = async () => {
    setVerifying(true); setMsg('');
    const res = await fetch('/api/otp/verify', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone, code }),
    });
    const data = await res.json();
    setVerifying(false);
    if (res.ok) { onVerified(phone); setMsg('인증되었습니다.'); }
    else setMsg(data.error ?? '인증 실패');
  };

  if (verified) {
    return <p className="text-xs text-green-600">✓ 휴대폰 인증 완료</p>;
  }

  return (
    <div className="space-y-2">
      <button type="button" onClick={send} disabled={sending}
        className="text-xs bg-gray-100 border border-gray-300 rounded px-3 py-1.5 text-gray-700 hover:bg-gray-200 disabled:opacity-50">
        {sending ? '발송 중...' : sent ? '인증번호 재발송' : '인증번호 발송'}
      </button>
      {sent && (
        <div className="flex gap-2">
          <input value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 4))}
            placeholder="인증번호 4자리" inputMode="numeric"
            className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-900" />
          <button type="button" onClick={verify} disabled={verifying || code.length !== 4}
            className="shrink-0 bg-gray-800 text-white text-xs rounded px-3 py-2 disabled:opacity-50">
            {verifying ? '확인 중...' : '확인'}
          </button>
        </div>
      )}
      {msg && <p className="text-xs text-gray-500">{msg}</p>}
    </div>
  );
}
